module.exports = __webpack_public_path__ + "static/img/alarm1.86bc80ee.png";